module.exports = ".form-check-input {\n  margin-left: 0; }\n\n.list-group-item {\n  padding: 0 0.25rem; }\n\n.filter-group {\n  position: relative; }\n  .filter-group .clear {\n    position: absolute;\n    top: 0.75rem;\n    right: 0.76rem;\n    cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/users/components/user.modal.scss
// module id = 587
// module chunks = 1